const LANGUAGE_KEY = 'language';
const LIKED_UNITS_KEY = 'likedUnits';
const SIGNING_OFFERS_PASSWORD_KEY = 'lease-signing-offers-password';
const SUBMIT_ATTEMPTED_KEY_PREFIX = 'rental-app-submit-attempted:';
const SUBMIT_ATTEMPTED = '1';

enum StorageKind {
  Local,
  Session,
}

const storageOf = (kind: StorageKind): Storage | undefined => {
  if (typeof localStorage === 'undefined') {
    return undefined;
  }
  return kind === StorageKind.Local ? localStorage : sessionStorage;
};

export class LocalStorageManager {
  public getLanguage(): string | undefined {
    return storageOf(StorageKind.Local)?.getItem(LANGUAGE_KEY) ?? undefined;
  }

  public setLanguage(language: string): void {
    storageOf(StorageKind.Local)?.setItem(LANGUAGE_KEY, language);
  }

  public getLikedUnitIds(): string[] {
    const stored = storageOf(StorageKind.Local)?.getItem(LIKED_UNITS_KEY);
    if (!stored) {
      return [];
    }
    try {
      const parsed: unknown = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
    } catch {
      return [];
    }
  }

  public setLikedUnitIds(unitIds: string[]): void {
    storageOf(StorageKind.Local)?.setItem(LIKED_UNITS_KEY, JSON.stringify(unitIds));
  }

  public getSigningOffersPassword(): string | undefined {
    return storageOf(StorageKind.Session)?.getItem(SIGNING_OFFERS_PASSWORD_KEY) ?? undefined;
  }

  public setSigningOffersPassword(password: string): void {
    storageOf(StorageKind.Session)?.setItem(SIGNING_OFFERS_PASSWORD_KEY, password);
  }

  public hasAttemptedSubmit(applicationId: string): boolean {
    return storageOf(StorageKind.Session)?.getItem(SUBMIT_ATTEMPTED_KEY_PREFIX + applicationId) === SUBMIT_ATTEMPTED;
  }

  public setAttemptedSubmit(applicationId: string): void {
    storageOf(StorageKind.Session)?.setItem(SUBMIT_ATTEMPTED_KEY_PREFIX + applicationId, SUBMIT_ATTEMPTED);
  }
}

export const localStorageManager = new LocalStorageManager();
